import { LinkableEntityType, ShowWithTourType } from '@api';

export const getShowArtists = (
  show: ShowWithTourType
): LinkableEntityType[] => {
  return [show.artist, show.coHeadliner1, show.coHeadliner2].filter(
    (artist) => artist !== null
  );
};
